import React, { Component } from 'react';

export class MyInput extends Component {

  constructor(props) {
    super(props);
    this.state = { value: this.props.text };

    // this.state.value=this.props.text;
    this.onChangeText = this.onChangeText.bind(this);

  }

  onChangeText(e) {
    //this.state.value=e.target.value;

    //      console.log(e.target.value);
    this.setState({ value: e.target.value });
    if (typeof this.props.onChange === "function")
      this.props.onChange(e.target.value, this.props.name);
  }


  componentDidMount() {
  }


  render() {
    var type = "text";
    if (this.props.IsPassword) {
      type = "password";
    }

    return (

      <div className="input-group" style ={{width:"100%"}}>
        <div className="input-group-prepend" style ={{width:"30%" ,textAlign:"center"}}>
          <span className="input-group-text" style ={{width:"100%" ,textAlign:"center"}}>{this.props.label}</span>
        </div>

          <div style ={{width:"70%"}}>
            <input type={type}
              placeholder={this.props.label}
              value={this.props.text}
              onChange={this.onChangeText}
              name={this.props.name}
              className="form-control"
              aria-label="Small"
              aria-describedby="inputGroup-sizing-sm"
              ref="myRef"
            />
          </div>
        </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/elements/MyInput.js